import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import NotepadApp from "@/pages/NotepadApp";

function AppRoutes() {
  const { user, checking } = useAuth();

  if (checking) {
    return (
      <div className="min-h-screen w-screen bg-[#0A0B10] flex items-center justify-center text-[#8B949E] font-mono text-sm">
        Memuat...
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={user ? <NotepadApp /> : <Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#12141D",
                border: "1px solid rgba(99, 102, 241, 0.3)",
                color: "#F8F9FA",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
